import {SUPERCOMPANIES} from '@constants';
import {cleanUrl} from '@jobseeker/lotus/utils';
import {Grid, Typography} from '@mui/material';
import {capitalizeFirstLetter} from '@utils';
import {Link} from '@jobseeker/lotus/elements';
import React from 'react';

const Companies = () => {
  return (
    <>
      <Typography component="h2" mt={2} mb={1}>
        Company
      </Typography>
      <Grid container spacing={2} mb={1}>
        {SUPERCOMPANIES.map(company => (
          <Grid item key={company.name} xs={4}>
            <Link href={`/${cleanUrl(company.slug)}-careers`} target="_blank">
              {capitalizeFirstLetter(company.name)} Jobs
            </Link>
          </Grid>
        ))}
      </Grid>
      <Link href={`/sitemap/company-careers`}>See All Companies {'>>'}</Link>
    </>
  );
};

export default Companies;
